import {RootMediator as BaseRootMediator} from "@dp-instant/2d";
import {injectable} from "inversify";
import {GameEvents} from "../GameEvents";
import Root from "../view/Root";

@injectable()
export class RootMediator extends BaseRootMediator {
    protected view: Root;

    protected getConfig() {
        return {...super.getConfig(), backgroundColor: 0xd0d0d0};
    }
    protected onResize() {
        super.onResize();
        const app = this.view.app;
        this.dispatch(GameEvents.RESIZE, {
            width: app.view.clientWidth,
            height: app.view.clientHeight
        });
    }
}
